module.exports = __webpack_public_path__ + "static/media/sfl_4.56c27f07.jpg";